module.exports = __webpack_public_path__ + "img/logo_mensagem_agradecimento_texto.3d31e677.png";